/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React, {CSSProperties} from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import {ListProps, RowItem} from '.'
import styles from '../style/list.css'
import {Loader} from '../Loader'

export function ListContent<Item extends RowItem>({
  items,
  columnSpecs,
  onRowClick,
  hasMoreData,
  onLoadMore,
  expandedState,
  ExpandedRowComponent
}: ListProps<Item>) {
  return (
    <div className={styles['list__content']}>
      <div>
        <InfiniteScroll
          loadMore={onLoadMore}
          hasMore={hasMoreData}
          threshold={50}
          loader={<Loader />}
          initialLoad={false}
          useWindow={false}
        >
          {items.map((item) => {
            return (
              <React.Fragment key={item.id}>
                <div
                  className={styles['list__row']}
                  onMouseUp={() => {
                    if (!window.getSelection() || window.getSelection()?.toString() === '') {
                      onRowClick && onRowClick(item)
                    }
                  }}
                >
                  {columnSpecs.map((spec) => {
                    let elementStyles: CSSProperties | undefined
                    if (spec.width) {
                      elementStyles = {
                        width: spec.width,
                        flexGrow: 0,
                        flexShrink: 0
                      }
                    }
                    return (
                      <div
                        key={`${spec.id}-${item.id}`}
                        style={elementStyles}
                        className={styles['list__row__column']}
                      >
                        <spec.Component item={item} />
                      </div>
                    )
                  })}
                </div>
                {expandedState.has(item.id) && ExpandedRowComponent ? (
                  <ExpandedRowComponent item={item} />
                ) : null}
              </React.Fragment>
            )
          })}
        </InfiniteScroll>
      </div>
    </div>
  )
}
